import { render, staticRenderFns } from "./home.vue?vue&type=template&id=639b5a58&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=639b5a58&prod&lang=scss&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=639b5a58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b5a58",
  null
  
)

export default component.exports